import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  setUserOnlineNotification,
  setNotificationPreferences,
  openEmailPreferences,
  openSoundPreference,
} from '@/utils/SessionUtils';
import cssStyles from './Dropdown.css';
import ToggleButton from '../common/ToggleButton/ToggleButton';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  setUserOnlineNotification(value) {
    const { sessionId } = this.props;
    setUserOnlineNotification(sessionId, value);
  }

  openEmailPreferences = e => {
    e.preventDefault();
    e.stopPropagation();
    const { sessionId } = this.props;
    openEmailPreferences(sessionId);
  };

  toggleOnlineNotifications = e => {
    e.preventDefault();
    e.stopPropagation();
    const { notificationPreferences } = this.props;
    this.setUserOnlineNotification(
      !notificationPreferences.userOnlineNotification
    );
  };

  toggle = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  setNotificationPreferences = (e, type, value) => {
    e.preventDefault();
    e.stopPropagation();
    const { sessionId } = this.props;
    setNotificationPreferences(sessionId, type, value);
  };

  openSoundPreference = e => {
    e.preventDefault();
    e.stopPropagation();
    openSoundPreference();
  };

  render() {
    const {
      notificationPreferences: {
        videoRingerDisabled,
        userOnlineNotification,
        toastersEnabled,
        audioEnabled,
      },
      soundPreference,
    } = this.props;

    const { isOpen } = this.state;

    return (
      <div
        role='menuitem'
        onKeyDown={() => {}}
        tabIndex='-1'
        className={cssStyles.dropdown_list_item}
        onClick={this.toggle}
      >
        <div className={cssStyles.menu_item_info}>
          <div className={cssStyles.menu_item_label}>
            <FormattedMessage id='notification_preferences' />
          </div>
        </div>
        <div
          className={classNames(cssStyles.menu_item_arrow, {
            [cssStyles.menu_item_arrow_reverse]: isOpen,
          })}
        />
        {isOpen && (
          <ul className={cssStyles.sub_dropdown_list}>
            <li
              role='menuitem'
              onKeyDown={() => {}}
              className={cssStyles.sub_dropdown_list_item}
              onClick={e =>
                this.setNotificationPreferences(e, 'toasters', !toastersEnabled)
              }
            >
              <span>
                <FormattedMessage id='popup_notifications' />
              </span>
              <ToggleButton isActive={toastersEnabled} />
            </li>
            <li
              role='menuitem'
              onKeyDown={() => {}}
              className={cssStyles.sub_dropdown_list_item}
              onClick={this.toggleOnlineNotifications}
            >
              <span>
                <FormattedMessage id='user_online_notifications' />
              </span>
              <ToggleButton isActive={userOnlineNotification} />
            </li>
            <li
              role='menuitem'
              onKeyDown={() => {}}
              className={cssStyles.sub_dropdown_list_item}
              onClick={e =>
                this.setNotificationPreferences(
                  e,
                  'videoRingerDisabled',
                  !videoRingerDisabled
                )
              }
            >
              <span>
                <FormattedMessage id='video_ringer' />
              </span>
              <ToggleButton isActive={videoRingerDisabled} />
            </li>
            <li
              role='menuitem'
              onKeyDown={() => {}}
              className={cssStyles.sub_dropdown_list_item}
              onClick={e =>
                this.setNotificationPreferences(e, 'audio', !audioEnabled)
              }
            >
              <span>
                <FormattedMessage id='audio_alerts' />
              </span>
              <ToggleButton isActive={audioEnabled} />
            </li>
            {audioEnabled && soundPreference && (
              <li
                role='menuitem'
                onKeyDown={() => {}}
                className={classNames(
                  cssStyles.sub_dropdown_list_item,
                  cssStyles.sound_menu_item
                )}
                onClick={this.openSoundPreference}
              >
                <span className={cssStyles.sound_menu_item_label}>
                  <FormattedMessage id='sound_preference' />
                </span>
                <span className={cssStyles.menu_item_label_right}>
                  {soundPreference && soundPreference.name}
                </span>
              </li>
            )}
            <li
              role='menuitem'
              onKeyDown={() => {}}
              className={cssStyles.sub_dropdown_list_item}
              onClick={this.openEmailPreferences}
            >
              <span>
                <FormattedMessage id='email_preferences' />
              </span>
              <div className={cssStyles.menu_item_popout} />
            </li>
          </ul>
        )}
      </div>
    );
  }
}

Notifications.propTypes = {
  sessionId: PropTypes.string.isRequired,
  soundPreference: PropTypes.object.isRequired,
  notificationPreferences: PropTypes.object.isRequired,
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/appMenu/Notifications.js